import { Breadcrumb, Typography } from 'antd';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HomeOutlined } from '@ant-design/icons';
import { routes } from '../../utils/constants/routes';

const { Title } = Typography;

const PageHeader = ({ title, extra }) => {
  const { subPath } = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const splitPathname = pathname.split('/').filter(Boolean);

  // Construction du breadcrumb
  const breadcrumbItems = [
    {
      title: (
        <Link to={routes.HOME}>
          <HomeOutlined />
        </Link>
      )
    }
  ];

  if (splitPathname[0]) {
    const firstPath = `/${splitPathname[0]}`;
    const firstLabel = t(`breadcrumbs.${splitPathname[0]}`);

    if (splitPathname.length === 1) {
      breadcrumbItems.push({
        title: <span>{firstLabel}</span>
      });
    } else {
      breadcrumbItems.push({
        title: <Link to={firstPath}>{firstLabel}</Link>
      });
    }
  } else {
    breadcrumbItems.pop();
  }

  if (splitPathname[1]) {
    const secondPath = subPath
      ? `/${splitPathname[0]}/${subPath}`
      : `/${splitPathname[0]}/${splitPathname[1]}`;

    const secondLabel = subPath
      ? t(`${splitPathname[0]}.${subPath}.title`)
      : t(`breadcrumbs.${splitPathname[1]}`);

    if (!splitPathname[2]) {
      breadcrumbItems.push({
        title: <span>{secondLabel}</span>
      });
    } else {
      breadcrumbItems.push({
        title: <Link to={secondPath}>{secondLabel}</Link>
      });
    }
  }

  if (subPath && splitPathname[2]) {
    const thirdLabel = t(`breadcrumbs.${splitPathname[2]}`);
    breadcrumbItems.push({
      title: <span>{thirdLabel}</span>
    });
  }

  return (
    <div className="ant-page-header ant-page-header-ghost">
      <Breadcrumb items={breadcrumbItems} separator=">" />
      <Title level={3} className="ant-page-header-heading-title">
        {title}
      </Title>
      {extra && <div className="ant-page-header-heading-extra">{extra}</div>}
    </div>
  );
};

export default PageHeader;
